import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engfinity-club-installation-press-release',
  templateUrl: './engfinity-club-installation-press-release.component.html',
  styleUrls: ['./engfinity-club-installation-press-release.component.scss']
})
export class EngfinityClubInstallationPressReleaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
